export const stationModels = {
    relink_station: 'relink_station',
    dudu_station: 'dudu_station',
};
